export const aboutInfo: {
  bio: string
} = {
  bio: `
    Hi! My name is Andrew and I love travelling, staying active, following sports, and working on DIY projects.
    I am a front-end web developer at Microsoft working as a tech lead on the Microsoft 365 Copilot UX team.
    I graduated from the University of Michigan in December 2020 with a master's degree in Computer Science and Engineering.
    My career goal is to use my passions to positively impact the lives of others while challenging myself to continually become a better version of myself.
    My professional interests lie in user interface design, web app architecture, and enterprise level scalability of systems co-created with AI.
  `
};
